module.exports = __webpack_public_path__ + "static/media/GO_C_enriched_and_unique_terms.e5c3f45c.zip";